import { useFeatureFlags } from '@usap/core'

const useMembershipEnabled = () => {
  const { f21 } = useFeatureFlags()
  if (f21) {
    return f21 === 'b' || f21 === '1' || f21.toString() === 'true'
  }
  return false
}

export default useMembershipEnabled
